// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fundamental-content .p-divider[data-v-72f97fe7]{margin:0 0}.fundamental-sub-content[data-v-72f97fe7]{margin-bottom:1rem}.fundamental-sub-content .capital-text[data-v-72f97fe7]{font-weight:700}.fundamental-sub-content .header-text[data-v-72f97fe7]{font-weight:500}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
